module.exports = __webpack_public_path__ + "static/fonts/montserrat-regular.5906fb8.ttf";